/*
  CTC carousel — shared behaviour for horizontal scroll carousels.
  Markup contract:
    <div data-ctc-carousel data-autoplay="5000"> ... </div>
      [data-carousel-track]  the scrolling track (overflow-x: auto)
      [data-carousel-prev]   previous button (optional)
      [data-carousel-next]   next button (optional)
  Autoplay: advances every data-autoplay ms; pauses on hover/focus/touch and
  when the tab is hidden; loops at the ends; disabled under reduced-motion.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gap(el) {
    var cs = getComputedStyle(el);
    return parseFloat(cs.columnGap || cs.gap || '0') || 0;
  }

  function init(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');

    function step() {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + gap(track) : track.clientWidth * 0.8;
    }
    function advance(dir) {
      var maxLeft = track.scrollWidth - track.clientWidth;
      if (dir > 0 && track.scrollLeft >= maxLeft - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && track.scrollLeft <= 4) {
        track.scrollTo({ left: maxLeft, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }
    }

    var interval = reduce ? 0 : parseInt(root.getAttribute('data-autoplay') || '0', 10);
    var paused = false, resumeT = null;
    function pauseFor() {
      paused = true;
      clearTimeout(resumeT);
      resumeT = setTimeout(function () { paused = false; }, Math.max(interval, 4000));
    }

    if (prev) prev.addEventListener('click', function () { advance(-1); if (interval) pauseFor(); });
    if (next) next.addEventListener('click', function () { advance(1); if (interval) pauseFor(); });

    if (interval) {
      setInterval(function () { if (!paused && !document.hidden) advance(1); }, interval);
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('pointerdown', pauseFor);
      track.addEventListener('touchstart', pauseFor, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ctc-carousel]').forEach(init);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
